/**
 * 权限指令
 * 使用方法：v-permission="'user/add'" 或 v-permission="['user/add', 'user/edit']"
 */

import store from '../store'

export default {
  inserted(el, binding) {
    const { value } = binding
    const userInfo = store.state.mutations.userInfo
    const permissionMap = store.state.mutations.permissionMap

    // 超级管理员拥有所有权限，不移除任何元素
    if (userInfo && userInfo.superman === 1) {
      return
    }

    if (value) {
      let hasPermission = false

      if (typeof value === 'string') {
        // 单个权限
        hasPermission = !!permissionMap[value]
      } else if (Array.isArray(value)) {
        // 多个权限，有任一权限即可
        hasPermission = value.some(permission => permissionMap[permission])
      }

      if (!hasPermission) {
        // 没有权限则移除元素
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error('权限指令需要传入权限标识，如 v-permission="\'user/add\'"')
    }
  }
}

/**
 * 权限检查函数
 */
export function checkPermission(permission) {
  const userInfo = store.state.mutations.userInfo
  // 超级管理员拥有所有权限
  if (userInfo && userInfo.superman === 1) {
    return true
  }
  const permissionMap = store.state.mutations.permissionMap
  if (typeof permission === 'string') {
    return !!permissionMap[permission]
  } else if (Array.isArray(permission)) {
    return permission.some(p => permissionMap[p])
  }
  return false
}

/**
 * 检查是否有所有权限
 */
export function checkAllPermissions(permissions) {
  const userInfo = store.state.mutations.userInfo
  // 超级管理员拥有所有权限
  if (userInfo && userInfo.superman === 1) {
    return true
  }
  if (!Array.isArray(permissions)) return false
  const permissionMap = store.state.mutations.permissionMap
  return permissions.every(p => permissionMap[p])
}



// WEBPACK FOOTER //
// ./src/utils/permission.js